const items = [
	{
		id: 8,
		name: "notification.type.all"
	},
	{
		id: 3,
		name: "notification.type.normal"
	},
	{
		id: 6,
		name: "notification.type.life"
	},
	{
		id: 7,
		name: "notification.type.vehicle"
	},
];

export default items;